<template>
  <div class="box5">
    <pageTitle title="案例实操串联考试大纲<br/>解决电商&出行&金融等领域<br/>实际应用难题" titleColor="#332114" />
    <div class="content">
      <ul class="tab-list">
        <li 
          v-for="(item, index) in list" 
          :class="{active: currIndex === index}"
          @click="checkTab(index)" 
          :key="index"
        >{{ item }}</li>
      </ul>
      <div class="info-box">
        <ul class="banner-list">
          <li v-for="(item, index) in currItem.loop" :key="index">
            <img :src="item.img" alt="">
          </li>
        </ul>
        <div class="title">{{ currItem.name }}</div>
        <div class="info" v-html="currItem.content"></div>
      </div>
    </div>
    <div class="btn-mask">
      <div class="btn" @click="show = true">查看全部</div>
    </div>
    <van-popup v-model="show" position="bottom" round>
      <div class="pop">
        <div class="pop-top">
          <div class="title">{{ currItem.name }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="pop-cont">
          <div class="pop-stit">
            <img src="../../../assets/coursePage/acp/box5/icon-1.png" alt="">
            <span>主讲内容</span>
          </div>
          <p class="pop-info pop-content" v-html="currItem.content"></p>
          <div class="pop-stit mt39">
            <img src="../../../assets/coursePage/acp/box5/icon-1.png" alt="">
            <span>项目收获</span>
          </div> 
          <p 
            class="pop-info pop-harvest" 
            v-for="(item, index) in currItem.harvest" 
            :key="index"
          >{{ item }}</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
      show: false,
      currIndex: 0,
      list: [
        '项目一',
        '项目二',
        '项目三',
        '项目四',
        '项目五',
      ],
      listInfo: [
        {
          name: '阿里云 ECS 项目实战',
          loop: [
            { img: require('../../../assets/coursePage/acp/box5/pic-1-1.png') },
            { img: require('../../../assets/coursePage/acp/box5/pic-1-2.png') }
          ],
          content: '本实践将以阿里云ECS云服务器为基础，详解ECS实例创建、网络配置、远程管理、服务安装配置，并以一个Web项目部署案例让学生快速上手阿里云ECS云服务器。',
          harvest: [
            '掌握 ECS 服务器配置与管理',
            '掌握 ECS 服务器远程管理操作',
            '掌握 ECS 服务器服务安装配置以及应用搭建'
          ]
        },
        {
          name: 'Dataworks/MaxCompute 项目实战',
          loop: [
            { img: require('../../../assets/coursePage/acp/box5/pic-2-1.png') },
            { img: require('../../../assets/coursePage/acp/box5/pic-2-2.png') }
          ],
          content: '本案例以滴滴出行为项目背景，详解异构数据源采集、大数据平台开发、智能建模、出行行业完整架构等等，覆盖阿里云DataWorks/MaxCompute全链路。',
          harvest: [
            '掌握DataWorks离线数据/实时数据采集工作',
            '能够基于Dataworks/MaxCompute完成数据建模与数据开发',
            '能够基于Dataworks/MaxCompute完成出行项目全链路开发工作'
          ]
        },
        {
          name: 'QuickBI产品实战-电商仪表板绘制',
          loop: [
            { img: require('../../../assets/coursePage/acp/box5/pic-3-1.png') },
            { img: require('../../../assets/coursePage/acp/box5/pic-3-2.png') }
          ],
          content: `
            1. 电商仪表板绘制<br/>
            2. 滴滴出行运营大屏<br/>
            数据可视化能力早已成为新时代优秀工程师必备素养，本课程以阿里云QuickBI为基础，使用QuickBI连接Excel表格以及阿里云RDS云数据库实例，打造电商仪表板绘制以及滴滴出行运营大屏案例。
          `,
          harvest: [
            '掌握BI报表开发流程和QuickBI工具使用',
            '掌握常见可视化图解绘制，如折线图、柱状图、饼状图、地图等',
            '掌握电商行业以及出行行业仪表板绘制工作'
          ]
        },
        {
          name: '淘宝母婴数据加速查询',
          loop: [
            { img: require('../../../assets/coursePage/acp/box5/pic-4-1.png') },
            { img: require('../../../assets/coursePage/acp/box5/pic-4-2.png') }
          ],
          content: '本实践将以阿里云实时计算Flink版为基础，使用Flink自带的MySQL Connector连接RDS云数据库实例，并以一个淘宝母婴订单实时查询的例子尝试上手Connector的数据捕获、数据变更等功能。',
          harvest: [
            '使用Flink实时计算平台创建并提交作业的方法',
            '编写基于Flink Table API SQL语句的能力',
            '使用MySQL Connector对数据库进行读取的方法'
          ]
        },
        {
          name: '基于 Flink + Hologres 构建实时数仓',
          loop: [
            { img: require('../../../assets/coursePage/acp/box5/pic-5-1.png') },
            { img: require('../../../assets/coursePage/acp/box5/pic-5-2.png') }
          ],
          content: '本实践以某个电商平台为例，通过搭建一套实时数仓，实现数据的实时加工清洗和对接上层应用数据查询，形成实时数据的分层和复用，支撑各个业务方的报表查询（交易大屏、行为数据分析、用户画像标签）以及个性化推荐等多个业务场景。',
          harvest: [
            '掌握采用 Flink + Hologres 架构构建实时数仓',
            '熟练创建 Catalog，并结合CDAS语法整库同步数据',
            '掌握 Hologres 实时数仓的简单应用场景'
          ]
        }
      ]
    }
  },
  created(){
    this.currItem = this.listInfo[0]
  },
  methods:{
    checkTab(index){
      this.currIndex = index
      this.currItem = this.listInfo[index]
    }
  }
}
</script>

<style lang="scss" scoped>
.box5 {
  padding: 76px 0 80px;
  background-image: url(../../../assets/coursePage/acp/box5/bg.png);
  position: relative;
  .content{
    margin-top: 40px;
    overflow: hidden;
    .tab-list{
      display: flex;
      padding: 10px 30px 30px;
      overflow-x: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      li{
        width: 160px;
        min-width: 160px;
        height: 76px;
        background-color: #ffffff;
        box-shadow: 0px 10px 20px 0px 
          #ffd9b2;
        border-radius: 14px;
        margin-right: 30px;
        text-align: center;
        line-height: 76px;
        font-size: 28px;
        color: #33210f;
        &:last-child{
          margin: 0;
        }
        &.active{
          background-image: linear-gradient(90deg, 
          #ff7f00 0%, 
          #ff6a00 100%);
          color: #fff;
        }
      }
    }

    .info-box{
      padding: 0 30px;
      .banner-list{
        display: flex;
        overflow-x: auto;
        padding-top: 50px;
        padding-bottom: 30px;
        &::-webkit-scrollbar {
          display: none;
        }
        li{
          min-width: 540px;
          width: 540px;
          height: 340px;
          box-shadow: 0px 6px 30px 0px 
            #ffe5cc;
          margin-right: 30px;
          &:last-child{
            margin: 0;
          }
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .title{
        font-family: PingFangSC-Medium;
        font-size: 32px;
        line-height: 24px;
        color: #332114;
        text-align: center;
        margin-top: 16px;
      }
      .info{
        width: 622px;
        height: 97px;
        font-family: PingFang-SC-Regular;
        font-size: 24px;
        line-height: 36px;
        color: #4d3f36;
        margin: 37px auto 0;
      }
    }
  }

  .btn-mask{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 250px;
	  background-image: linear-gradient(rgba(255,255,255,.2) 0%, rgba(255,255,255, 1) 60%, rgba(255,255,255,1) 100%);
    padding-top: 110px;
    box-sizing: border-box;
    .btn{
      width: 180px;
      height: 60px;
      background-image: linear-gradient(90deg, 
        #ff7f00 0%, 
        #ff6a00 100%);
      border-radius: 30px;
      line-height: 60px;
      text-align: center;
      font-size: 28px;
	    color: #ffffff;
      margin: 0 auto;
    }
  }

  ::v-deep{
    .pop{
      padding: 50px;
      .pop-top{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title{
          font-family: PingFangSC-Medium;
          font-size: 36px;
          line-height: 36px;
          color: #332114;
        }
        .close{
          width: 36px;
          height: 36px;
          background-image: url(../../../assets/coursePage/acp/box5/icon-close.png);
          background-size: 25px 25px;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .pop-cont{
        margin-top: 48px;
        .pop-stit{
          display: flex;
          align-items: center;
          margin-bottom: 21px;
          img{
            width: 30px;
            height: 30px;
            margin-right: 10px;
          }
          span{
            font-size: 30px;
            line-height: 30px;
            color: #332114;
          }
        }
        .pop-info{
          font-family: PingFangSC-Regular;
          font-size: 24px;
          line-height: 36px;
          color: #4d3f36;
          padding-left: 39px;
  
          &.pop-harvest{
            padding-left: 59px;
            position: relative;
            &::before{
              content: "";
              position: absolute;
              top: 8px;
              left: 41px;
              width: 8px;
              height: 8px;
              background-color: #ff6a00;
              border-radius: 50%;
            }
          }
        }
        .mt39{
          margin-top: 39px;
        }
      }
    }
  }
}
</style>